import type Mithril from 'mithril';
import * as wx from '@wecom/jssdk';
import Component, { ComponentAttrs } from 'flarum/common/Component';
import app from 'flarum/forum/app';

import { onLoginSuccess } from '../../common/utils';
import LoadingModal from './LoadingModal';

export interface WeComLoginAttrs extends ComponentAttrs {
  corpId: string;
  agentId: string;
}

export default class WeComLogin<T extends WeComLoginAttrs = WeComLoginAttrs> extends Component<T> {
  static login(code: string) {
    return app.request({
      method: 'POST',
      url: '/adapter-api/wecom/login',
      body: { code },
    });
  }

  wxLogin!: wx.WWLoginInstance;

  oncreate(vnode: Mithril.VnodeDOM<T, this>) {
    super.oncreate(vnode);

    this.wxLogin = wx.createWWLoginPanel({
      el: '#wecom-sdk-login',
      params: {
        login_type: wx.WWLoginType.corpApp,
        appid: this.attrs.corpId,
        agentid: this.attrs.agentId,
        redirect_uri: location.origin,
        redirect_type: wx.WWLoginRedirectType.callback,
        state: `${Math.random()}`,
        panel_size: wx.WWLoginPanelSizeType.small,
      },
      onLoginSuccess({ code }) {
        app.modal.show(LoadingModal);
        WeComLogin.login(code).then(onLoginSuccess);
      },
      onLoginFail(err) {
        console.log(err);
      },
    });
  }

  onremove(vnode: Mithril.VnodeDOM<T, this>) {
    super.onremove(vnode);
    this.wxLogin?.unmount();
  }

  view() {
    return <div id="wecom-sdk-login" />;
  }
}
